

















































import Vue from 'vue';
import { UserClient, User } from '@/assets/src/clients/user_client';
import { IS_PROD, COGNITO_USER_URL } from '@/assets/src/configs';

import ProductAccessPeriodList from '@/components/ProductAccessPeriodList.vue';
import UserDemoList from '@/components/UserDemoList.vue';

const stripeCustomerUrlTemplate = IS_PROD
  ? 'https://dashboard.stripe.com/customers/'
  : 'https://dashboard.stripe.com/test/customers/';

export default Vue.extend({
  name: 'InspectUser',

  components: { ProductAccessPeriodList, UserDemoList },

  methods: {
    async getUser(): Promise<void> {
      this.user = await this.userClient.getUser(this.cognitoId);
      this.stripeCustomerUrl = stripeCustomerUrlTemplate + this.user.stripe_customer_id;
      this.cognitoUserUrl = COGNITO_USER_URL + this.user.cognito_username;
    },
  },

  activated() {
    this.cognitoId = this.$route.params.cognito_id;
    this.getUser();
  },

  data() {
    return {
      cognitoId: '',
      stripeCustomerUrl: '',
      cognitoUserUrl: '',

      userClient: new UserClient(),
      user: null as User | null,
    };
  },
});
